import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../../Assets/developer.css";
import { useState } from "react";

export default function CreateSurvey() {
  const navigate = useNavigate();
  const [surveyorName, setSurveyorName] = useState("");
  const [applicationNumber, setApplicationNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [onRent, setOnRent] = useState("");
  const [address, setAddress] = useState("");
  const [connectionStatus, setConnectionStatus] = useState("");
  const saveSurvey = async (e) =>{
    if(connectionStatus==1){
      navigate("/create/stepone");
    }
    else{
            navigate("/create/steptwo");
    }
    //Swal.fire({ surveyorName });
  }
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col-lg-6 justify-content-center form-center">
          <div className="form-top-design">
            <form>
              <div className="form-group">
                <label for="surveyor_name">Surveyor Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setSurveyorName(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Application Number</label>(
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setApplicationNumber(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Customer Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setCustomerName(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Mobile Number</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setMobileNumber(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Email</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setEmail(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">On Rent or Not</label>
                <input
                  type="radio"
                  value="Yes"
                  name="is_on_rent"
                  onSelect={(event) => setOnRent(event.target.value)}
                />{" "}
                Yes
                <input
                  type="radio"
                  value="No"
                  name="is_on_rent"
                  onSelect={(event) => setOnRent(event.target.value)}
                />{" "}
                No
              </div>
              <div className="form-group">
                <label for="surveyor_name">Address</label>
                <textarea
                  name="address"
                  className="form-control"
                  onChange={(event) => setAddress(event.target.value)}
                ></textarea>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Connection Status</label>
                <select
                  name="connection_status"
                  className="form-control"
                  onChange={(event) => setConnectionStatus(event.target.value)}
                >
                  <option value="select">select</option>
                  <option value="0">
                    Plumbing done with meter
                  </option>
                  <option value="1">
                    Plumbing done without meter
                  </option>
                  <option value="2">House Locked</option>
                  <option value="3">Address not Found</option>
                </select>
                <div className="form-group elements-div">
                  <input
                    type="button"
                    name="submit"
                    value="Next"
                    className="next-button"
                    onClick={saveSurvey}
                  ></input>
                  <a href="#" className="clear-link">
                    Clear
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
